/* global Vimeo */

(function () {
  function initGettingStartedVideo () {
    var video = document.getElementById('su-admin-about-getting-started-video')
    var button = document.getElementById('su-admin-about-getting-started-video-button')
    var iframe = document.getElementById('su-admin-about-getting-started-video-iframe')

    if (!iframe) {
      return
    }

    var player = new Vimeo.Player(iframe, { dnt: 1 })

    button.addEventListener('click', function () {
      button.classList.add('su-admin-u-hidden')
      iframe.classList.remove('su-admin-u-hidden')
      player.play()
    })

    player.on('loaded', function () {
      video.classList.remove('su-admin-about-getting-started-video-loading')
      button.classList.remove('su-admin-u-hidden')
    })

    player.on('ended', function () {
      player.exitFullscreen()
      button.classList.remove('su-admin-u-hidden')
      iframe.classList.add('su-admin-u-hidden')
    })

    player.on('play', function () {
      button.classList.add('su-admin-u-hidden')
      iframe.classList.remove('su-admin-u-hidden')
    })
  }

  document.addEventListener('DOMContentLoaded', initGettingStartedVideo)
})()
